/* eslint-disable no-unreachable */
// 绘制图表-通用部分

import { stopHorizontalScroll } from '@/utils/nativeBridge';
import { numeral } from '@fund/basic-lib';
import tools from '@fund/data';
import { market } from '../config';

// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 统一字体
const fontSize = 10;

export default () => ({

  // 数据配置
  sourceConfig: {
    date: {
      range: [0, 1],
    },
  },

  // 网格配置
  yAxisGridConfig: {
    grid: {
      lineDash: null,
      lineWidth: 0.5,
      stroke: '#eee',
    },
  },

  xAxisGridConfig: {
    line: {
      lineWidth: 0.5,
      stroke: '#eee',
    },
  },

  // Y轴提示样式
  yTipsConfig: {
    fontSize, // 字体大小
    fill: '#fff',
  },

  // Y轴刻度样式
  yAxisConfig: {
    fontSize, // 字体大小
    fill: '#666',
  },

  // X轴刻度样式
  xAxisConfig: {
    fontSize, // 字体大小
    fill: '#666',
  },

  // 通用提示配置
  tooltipConfig: {
    alwaysShow: false,
    showCrosshairs: true,
    custom: true,
    showXTip: true,
    showYTip: true,
    snap: true,
    crosshairsType: 'xy',
    showTooltipMarker: true,
///////////////////////////////////
///////////////////////
/////////////
/////////////////////////////////
    triggerOff: 'touchend',
/////////////
    crosshairsStyle: {
      lineDash: [4],
      stroke: '#f40',
    },
    xTipBackground: {
      fill: '#f40',
    },
    xTip: {
      fontSize, // 字体大小
      fill: '#fff', // 字体颜色
    },
    yTipBackground: {
      fill: '#f40',
    },
  },

  // 添加极坐标数据
  formatPolarPoint: (json, index, row, dateName) => {
    const space = Math.trunc(row.Datas.length * 0.1);
    let lineEndIndex = index + space;
    let site = 'left';
    if (index > row.Datas.length / 2) {
      site = 'right';
      lineEndIndex = index - space;
    }
    return Object.assign(json, {
      tag: 1,
      site,
      lineEndData: row.Datas[lineEndIndex][dateName],
    });
  },

  // 设置买卖点
  setBuyAndSalePoint: (json, buyAndSellPointData, needadd, nextdate) => {
    let dottedType = 3;
    // 存在后端买点 需要加上后端买点
    if (buyAndSellPointData.hdSellPoints && buyAndSellPointData.hdSellPoints.length > 0) {
      // eslint-disable-next-line array-callback-return
      buyAndSellPointData.hdSellPoints.map((date) => {
        if (json.date === date) {
          // console.log(`==12===${date}`);
          dottedType = 12;
        }
        if (needadd && nextdate.length > 0) {
          if (json.date < date && nextdate > date) {
            // console.log(`==12=><==${json.date} data==${date}`);
            dottedType = 12;
          }
        }
      });
    }
    // eslint-disable-next-line array-callback-return
    buyAndSellPointData.qdSellPoints.map((date) => {
      if (json.date === date) {
        // console.log(`===2==${date}`);
        dottedType = 2;
      }
      if (needadd && nextdate.length > 0) {
        if (json.date < date && nextdate > date) {
          // console.log(`==2=><==${json.date} data==${date}`);
          dottedType = 2;
        }
      }
    });
    // 存在后端买点 需要加上后端买点
    if (buyAndSellPointData.hdBuyPoints && buyAndSellPointData.hdBuyPoints.length > 0) {
      // eslint-disable-next-line array-callback-return
      buyAndSellPointData.hdBuyPoints.map((date) => {
        // console.log(`hdBuyPoints ====== bdate----${date} in---${json.date} next---${nextdate}`);
        if (json.date === date) {
          dottedType = 11;
        }
        if (needadd && nextdate.length > 0) {
          if (json.date < date && nextdate > date) {
            dottedType = 11;
          }
        }
      });
    }
    // eslint-disable-next-line array-callback-return
    buyAndSellPointData.qdBuyPoints.map((date) => {
      // console.log(`BuyPoints ====== bdate----${date} in---${json.date} next---${nextdate}`);
      if (json.date === date) {
        dottedType = 1;
      }
      if (needadd && nextdate.length > 0) {
        if (json.date < date && nextdate > date) {
          // console.log(`BuyPoints ====== bdate----${date} in---${json.date} next---${nextdate}`);
          dottedType = 1;
        }
      }
    });
    return Object.assign(json, {
      dottedType,
      ...json,
    });
  },
  // 整合买卖点数据
  configureBuyAndRealData: (row, buyAndSellPointData, timeName, datekey) => {
    const rowData = row;
    let dataList = [];
    dataList = dataList.concat(
      buyAndSellPointData.BuyPoints,
      buyAndSellPointData.SellPoints,
    );
    // 去重
    dataList = Array.from(new Set(dataList));
    // 排序
    const bsDateList = dataList.sort();
    let contdata = [];
    if (bsDateList.length > 0) {
    // eslint-disable-next-line array-callback-return
      rowData.Datas.map((ditem, index) => {
        contdata.push(ditem);
        if (timeName === '近5年' || timeName === '成立来') {
          let nextdate = '';
          if (rowData.Datas.length > (index + 1)) {
            nextdate = rowData.Datas[index + 1][`${datekey}`];
          }
          if (nextdate.length > 3 && bsDateList.length > 0) {
            bsDateList.forEach((bsDate) => {
              if (ditem[`${datekey}`] === bsDate) {
                // 不处理
              }
              if (ditem && ditem[`${datekey}`]) {
                if (ditem[`${datekey}`] < bsDate && nextdate > bsDate) {
                  // 拷贝
                  const obj = JSON.parse(JSON.stringify(ditem));
                  obj[`${datekey}`] = bsDate;
                  contdata.push(obj);
                }
              }
            });
          }
        }
      });
    } else {
      contdata = rowData.Datas;
    }
    return contdata;
  },
  // 设置变动点
  // 变动类型：1巨额赎回 2基金经理变更 3基金转型 4基金清盘 6分红
  setChangedPointNew: (json, row) => {
    let changedType = 0;
    let changedPointData = [];
    // const rowData = row;
    // rowData.Expansion.FundMNChangeList = [
    //   { PDATE: '2020-03-27', STYPE: 1 },
    //   { PDATE: '2020-04-13', STYPE: 2 },
    // ];
    try { changedPointData = row.Expansion.FundMNChangeList; } catch (err) { console.error(err); }

    // eslint-disable-next-line array-callback-return
    changedPointData.map((item) => {
      if (json.tag && (json.date === item.PDATE || json.date === item.FSRQ)) {
        changedType = item.STYPE;
      }
    });
    if (changedType === 3) {
      changedType = 0;
    }
    if (changedType === 4) {
      changedType = 0;
    }
    if (changedType === 6 || changedType === '6') {
      changedType = 6;
    }
    // console.log(json);
    return Object.assign(json, {
      changedType,
      ...json,
    });
  },
  // 设置变动点
  // 变动类型：1巨额赎回 2基金经理变更 3基金转型 4基金清盘
  setChangedPoint: (json, row) => {
    let changedType = 0;
    let changedPointData = [];
    // const rowData = row;
    // rowData.Expansion.FundMNChangeList = [
    //   { PDATE: '2020-03-27', STYPE: 1 },
    //   { PDATE: '2020-04-13', STYPE: 2 },
    // ];
    try { changedPointData = row.Expansion.FundMNChangeList; } catch (err) { console.error(err); }

    // eslint-disable-next-line array-callback-return
    changedPointData.map((item) => {
      if (json.tag && (json.date === item.PDATE || json.date === item.FSRQ)) {
        changedType = item.STYPE;
      }
    });
    if (changedType === 3) {
      changedType = 0;
    }
    if (changedType === 4) {
      changedType = 0;
    }
    if (changedType === 6 || changedType === '6') {
      changedType = 0;
    }
    // console.log(json);
    return Object.assign(json, {
      changedType,
      ...json,
    });
  },

  // 获取最大值
  getMaxVal(list) {
    let max = -999999;
    let min = 99999999;
    // eslint-disable-next-line array-callback-return
    list.map((d) => {
      max = Math.max(d.value, max);
      min = Math.min(d.value, min);
    });
    return (max + (max - min) / 10) * 1.001;
  },

  // 绘制极坐标提示
  drawPolarTips: (data, chart, dateType) => {
    // 设置极点提示
    let min = null;
    let max = null;
    // eslint-disable-next-line array-callback-return
    data.map((d) => {
      if (d.tag) {
        // eslint-disable-next-line no-unused-expressions
        (!min || d.value < min.value) && (min = d);
        // eslint-disable-next-line no-unused-expressions
        (!max || d.value > max.value) && (max = d);
      }
    });

    // 无波动不展示极点
    if (min === max) return;

    // eslint-disable-next-line array-callback-return
    [min, max].map((type) => {
      const space = window.innerWidth * 0.14;
      let content = '--';
      switch (dateType) {
        case 'dateType:price':
          content = numeral(type.value).format('0.0000', Math.trunc);
          break;
        case 'dateType:rate':
          content = numeral(type.value).format('0.0000%', Math.trunc);
          break;
        default:
          content = numeral(type.value).format('0.00%', Math.trunc);
          break;
      }
      chart.guide().text({
        position: [type.date, type.value],
        content,
        style: {
          fill: '#808080',
          textAlign: 'center',
          textBaseline: 'center',
          fontSize: 11, // 字体大小
        },
        offsetX: type.site === 'left' ? space : -space,
        offsetY: 2,
      });
      chart.guide().line({
        start: [type.date, type.value],
        end: [type.lineEndData, type.value],
        style: {
          fill: '#808080',
        },
      });
    });
  },

  // 绘制水印
  // drawLogo: (chart, offsetY, position) => {
  //   chart.guide().text({
  //     position: position || ['max', 'max'],
  //     content: '天天基金',
  //     style: {
  //       fill: '#d9d9d9',
  //       fontSize: (30 / 750) * window.innerWidth,
  //       fontWeight: 'bold',
  //     },
  //     offsetX: -window.innerWidth * 0.1,
  //     offsetY: offsetY || window.innerWidth * 0.01,
  //   });
  // },
  drawLogo: () => {},

  // 画买卖点
  drawTradeMarker: (data, chart) => {
    let guideH = chart.get('height') * 0.9;

    let hdguideH = chart.get('height') * 0.8;

    let buyPoint = null;
    let salePoint = null;
    let buyPointClass = '';
    let salePointSiteClass = '';

    let hdbuyPoint = null;
    let hdsalePoint = null;
    let hdbuyPointClass = '';
    let hdsalePointSiteClass = '';

    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.dottedType === 1) {
        buyPoint = d;
        buyPointClass = i > data.length * 0.7 ? 'marker-right' : '';
      }
    });
    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.dottedType === 2) {
        salePoint = d;
        salePointSiteClass = i > data.length * 0.7 ? 'marker-right' : '';
      }
    });
    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.dottedType === 11) {
        hdbuyPoint = d;
        hdbuyPointClass = i > data.length * 0.7 ? 'marker-right' : '';
      }
    });
    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.dottedType === 12) {
        hdsalePoint = d;
        hdsalePointSiteClass = i > data.length * 0.7 ? 'marker-right' : '';
      }
    });

    let qdm = '买了';
    if (hdbuyPoint || hdsalePoint) {
      qdm = '买了(前端)';
    }
    // eslint-disable-next-line no-unused-expressions
    buyPoint && chart.guide().html({
      position: [buyPoint.date, 'min'],
      html: `
          <div class="needremove marker marker-buy ${buyPointClass}" style="height:${guideH}px;">
            <span>${qdm}</span>
          </div>
        `,
      offsetY: -guideH / 2.3,
    });

    // eslint-disable-next-line no-unused-expressions
    hdbuyPoint && chart.guide().html({
      position: [hdbuyPoint.date, 'min'],
      html: `
          <div class="needremove marker marker-buy ${hdbuyPointClass}" style="height:${hdguideH}px;">
            <span>买了(后端)</span>
          </div>
        `,
      offsetY: -hdguideH / 2.3,
    });
    let qds = '卖了';
    if (hdbuyPoint || hdsalePoint) {
      qds = '卖了(前端)';
    }
    guideH = chart.get('height') * 0.7;
    hdguideH = chart.get('height') * 0.6;
    // eslint-disable-next-line no-unused-expressions
    salePoint && chart.guide().html({
      position: [salePoint.date, 'min'],
      html: `
          <div class="needremove marker marker-sale ${salePointSiteClass} marker-bottom" style="height:${hdguideH}px;">
            <span>${qds}</span>
          </div>
        `,
      offsetY: -hdguideH / 2.3,
    });

    // eslint-disable-next-line no-unused-expressions
    hdsalePoint && chart.guide().html({
      position: [hdsalePoint.date, 'min'],
      html: `
          <div class="needremove marker marker-sale ${hdsalePointSiteClass} marker-bottom" style="height:${guideH}px;">
            <span>卖了(后端)</span>
          </div>
        `,
      offsetY: -guideH / 1.8,
    });
    const stroke = '#fff';
    const lineWidth = '1';
    // eslint-disable-next-line max-len
    const fillList = [false, '#FF4400', '#007BE4', false, false, false, false, false, false, false, false, '#FF4400', '#007BE4'];
    // eslint-disable-next-line max-len
    const strokeList = [false, stroke, stroke, false, false, false, false, false, false, false, false, stroke, stroke];
    // eslint-disable-next-line max-len
    const lineWidthList = [false, lineWidth, lineWidth, false, false, false, false, false, false, false, false, lineWidth, lineWidth];
    chart.point()
      .position('date*value')
      .size('dottedType', (val) => (val ? 3 : 0))
      .style('dottedType', {
        fill: (val) => fillList[val] || false,
        stroke: (val) => strokeList[val] || false,
        lineWidth: (val) => lineWidthList[val] || false,
      });
  },

  // 画结束点
  drawEndPoint: (chart, data, nowColor) => {
    let lastPoint = null;
    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.rise !== null) {
        lastPoint = d;

        // 最后一个点不显示
        if (i === data.length - 1) {
          lastPoint = null;
        }
      }
    });
    const bgColor = nowColor;
    // eslint-disable-next-line no-unused-expressions
    lastPoint && chart.guide().html({
      position: [lastPoint.date, lastPoint.value],
      html: `
          <div class="needremove last-point">
            <div class="last-point-bg" style="background:${bgColor};"></div>
            <span  class="last-point-dotted" style="background:${bgColor};"></span>
          </div>
        `,
    });
  },

  // 画变动点
  drawChangedMarker: (data, chart, alertTips) => {
    const guideH = chart.get('height') * 0.8;

    // 每类变动点只显示最新点的提示
    const markerlist = {};

    // eslint-disable-next-line array-callback-return
    data.map((d, i) => {
      if (d.changedType) {
        markerlist[d.changedType] = {
          data: d,
          class: i > data.length * 0.7 ? 'marker-right' : '',
        };
      }
    });

    // eslint-disable-next-line array-callback-return
    // data.map((d, i) => {
    //   if (d.dottedType === 1) {
    //     buyPoint = d;
    //     buyPointClass = i > data.length * 0.7 ? 'marker-right' : '';
    //   }
    // });

    let isBottom = false;
    // eslint-disable-next-line array-callback-return
    Object.keys(markerlist).map((type) => {
      const pointData = markerlist[type].data;
      const pointClass = markerlist[type].class;
      const markerConfig = market.change[type - 0];

      if (!markerConfig) return;

      const guide = chart.guide().html({
        position: [pointData.date, 'min'],
        html: `
            <div class="needremove marker marker-changed ${isBottom ? 'marker-bottom' : ''} ${pointClass}" style="height:${guideH}px;">
              <span>${markerConfig.title}</span>
            </div>
          `,
        offsetY: -guideH / 2.3,
      });

      setTimeout(() => {
        guide.element.onclick = () => {
          alertTips(
            `${pointData.date} ${markerConfig.content}`,
            markerConfig.appLink,
            markerConfig.webLink,
          );
        };
      }, 300);

      isBottom = !isBottom;
    });

    const color = '#ff7000';
    const stroke = '#fff';
    const lineWidth = '1';
    chart.point()
      .position('date*value')
      .size('changedType', (val) => (val ? 3 : 0))
      .style('changedType', {
        fill: (val) => [
          false, color, color, color, color, color][val] || false,
        stroke: (val) => [
          false, stroke, stroke, stroke, stroke, stroke][val] || false,
        lineWidth: (val) => [
          false, lineWidth, lineWidth, lineWidth, lineWidth, lineWidth][val] || false,
      });
  },

  // 画变动点
  drawChangedFHMarker: (chart) => {
    chart.point()
      .position('date*value')
      .size('changedType', (val) => (val === 6 ? 3 : 0))
      .style('changedType', {
        fill: '#ff7000',
        stroke: '#fff',
        lineWidth: 1,
      });
  },

  // 创建十字线组件
  createToolTipsList(chart) {
    // 辅助延长线
    const toolsTips = chart.guide().html({
      position: [999999999, 99999999],
      html: '<div class="needremove tools-tips-iine"></div>',
      offsetX: 1,
      offsetY: -10,
    });

    // 纵轴辅助线
    const toolsTipsY = chart.guide().line({
      top: true,
      style: {
        stroke: '#f40',
        lineDash: [4],
        lineWidth: 1,
      },
      limitInPlot: true,
    });

    // 横轴辅助线
    const toolsTipsX = chart.guide().line({
      top: true,
      style: {
        stroke: '#f40',
        lineDash: [4],
        lineWidth: 1,
      },
      limitInPlot: true,
    });

    // 选择的点
    const selectPoint = chart.guide().point({
      top: true,
      position: [999999999, 99999999],
      style: {
        fill: '#fff',
        stroke: '#f40',
        r: 4,
        lineWidth: 2,
      },
    });

    // 纵轴提示
    const yTips = chart.guide().html({
      position: [999999999, 99999999],
      html: '<div"></div>',
      alignX: 'right',
      offsetX: -12,
    });

    // 横轴提示
    const xTips = chart.guide().html({
      position: [999999999, 99999999],
      html: '<div"></div>',
      offsetY: 14,
    });

    return {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };
  },

  // 显示十字线
  showToolTips(toolTipsList, point, formateVal, formateDate) {
    return;
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = toolTipsList;
    console.log(toolsTips);
    // 设置辅助线延长线位置
    // toolsTips.position = [point.title, 'max'];
    // toolsTips.repaint();

    // 设置y轴辅助线位置
    toolsTipsY.start = [point.title, 'max'];
    toolsTipsY.end = [point.title, 'min'];
    toolsTipsY.repaint();

    // 设置x轴辅助线位置
    toolsTipsX.start = ['min', point.value];
    toolsTipsX.end = ['max', point.value];
    toolsTipsX.repaint();

    // 设置选中的点
    selectPoint.position = [point.title, point.value];
    selectPoint.repaint();

    // 提示样式
    const tipsStyle = `
      background: #f40;
      color: #fff;
      font-size: ${(20 / 750) * window.innerWidth}px;
      padding: ${(4 / 750) * window.innerWidth}px ${(4 / 750) * window.innerWidth}px;
      vertical-align: top;
      border-radius: ${(4 / 750) * window.innerWidth}px;
      white-space: nowrap;
    `;

    // 纵轴提示
    const val = formateVal ? formateVal(point.value) : numeral(point.value).format('0.00%', Math.trunc);
    yTips.html = `<div style="${tipsStyle}">${val}</div>`;
    yTips.position = ['min', point.value];
    yTips.repaint();

    // 横轴提示
    const dateVal = point.title || point.date;
    const date = formateDate ? formateDate(dateVal) : dateVal.substring(5);
    xTips.html = `<div style="${tipsStyle}">${date}</div>`;
    xTips.position = [point.title, 'min'];
    xTips.alignX = 'center';
    if (point.origin.index === 0) {
      xTips.alignX = 'left';
    }
    if (point.origin.index === point.origin.max - 1) {
      xTips.alignX = 'right';
    }
    xTips.repaint();
  },

  // 隐藏十字线
  hideToolTIps(toolTipsList) {
    return;
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = toolTipsList;

    toolsTips.position = [999999999, 99999999];
    toolsTips.repaint();

    toolsTipsY.start = ['min', 'min'];
    toolsTipsY.end = ['min', 'min'];
    toolsTipsY.repaint();

    toolsTipsX.start = ['min', 'min'];
    toolsTipsX.end = ['min', 'min'];
    toolsTipsX.repaint();

    selectPoint.position = [999999999, 99999999];
    selectPoint.repaint();

    xTips.position = [999999999, 99999999];
    xTips.repaint();

    yTips.position = [999999999, 99999999];
    yTips.repaint();
  },

  // 十字线激活时禁止上下滑动
  tooltipOnChange() {
    // if (document.body.className.indexOf(' body-locked') === -1) {
    //   document.body.className += ' body-locked';
    // }
    window.isShowingToolTips = true;
    stopHorizontalScroll({});
  },

  // 十字线消失是恢复上下滑动
  tooltipOnHide() {
    window.isShowingToolTips = false;
    // document.body.className = document.body.className.replace(' body-locked', '');
    // setTimeout(() => {
    //   openHorizontalScroll({});
    // }, 300);
  },

  // 字段为空值时，用数组中相邻数据相同字段的值
  getDataWhenEmpty(list, index, keyName) {
    const nowVal = list && list[index] && list[index][keyName];
    if (tools.hasData(nowVal)) return nowVal;

    let step = 1;
    let val = 0;
    let existed = false;
    let stop = false;
    try {
      while ((!existed || val > list.length - 1) && !stop) {
        const lastVal = list[index - step] && list[index - step][keyName];
        const nextVal = list[index + step] && list[index + step][keyName];
        if (tools.hasData(lastVal)) {
          val = lastVal;
          existed = true;
        } else if (tools.hasData(nextVal)) {
          val = nextVal;
          existed = true;
        }
        step += 1;
        if (step > 300) {
          stop = true;
        }
      }
    } catch (err) {
      // console.log(err);
    }
    return val;
  },

});
